import { useState, useEffect } from 'react';
import { readJSON, writeJSON, subscribeKey } from '../services/deviceStore';

/**
 * useState persisted on the device under `key`. Synced keys (see services/deviceStore) also
 * follow the profile when signed in, so a change made on another device shows up here.
 */
export function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => readJSON(key, initialValue));
  useEffect(() => subscribeKey(key, () => setStoredValue(readJSON(key, initialValue))), [key]); // eslint-disable-line react-hooks/exhaustive-deps
  const setValue = (value) => {
    setStoredValue((prev) => {
      const next = value instanceof Function ? value(prev) : value;
      try { writeJSON(key, next); } catch (error) { console.log(`Error saving ${key} to localStorage:`, error); }
      return next;
    });
  };
  return [storedValue, setValue];
}
